import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Assuming you're using react-router for navigation
import { Scanner } from '@yudiel/react-qr-scanner'

const QRScanner = () => {
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [debug, setDebug] = useState("not yet");
    const [error, setError] = useState("no error");

    const handleScan = (newData) => {
        setData(newData);
        if (newData) {
            setDebug("scanned");
            navigate(newData[0]["rawValue"])
        } else {
            setDebug("no data");
        }
    };

    const handleError = (error) => {
        setError(error);
    }

    return (
        <div>
            <label>{debug}</label>
            {/*<label>{error}</label>*/}
            {/*<label>{data && JSON.stringify(data)}</label>*/}
            {/*<label>{data && data[0] && JSON.stringify(data[0])}</label>*/}
            {/*<label>{data && data[0] && data[0]["rawValue"] && data[0]["rawValue"]}</label>*/}
            <Scanner onScan={(result) => handleScan(result)} onError={(error) => handleError(error)} />
        </div>
    );
};

export default QRScanner;